import React from 'react';
export function Footer() {
  return <footer className="bg-black text-white/50 py-6 px-4 md:px-6 lg:px-8 border-t border-white/10" data-id="element-111">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-112">
        <div className="text-xs font-medium space-y-1" data-id="element-113">
          <p data-id="element-114">© Renovación Sin Obras — Todos los derechos reservados</p>
          <p data-id="element-115">Producto digital con acceso inmediato tras el pago.</p>
        </div>
      </div>
    </footer>;
}